import React, { useState, ReactNode, useMemo } from 'react';
import { AlertColor } from '@mui/material';
import { Toast } from '../components';
import { ToastContext, ToastContextType } from './toast-context-core';

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('info');

  const showToast = (message: string, severity: AlertColor = 'info') => {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo<ToastContextType>(() => ({ showToast }), []);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <Toast open={open} message={message} severity={severity} onClose={handleClose} />
    </ToastContext.Provider>
  );
};
